// extracted by mini-css-extract-plugin
var _1 = "y1pJM_rIV8cD2t3lf3GB";
export { _1 as "row" }
